/* eslint no-console: 0 */

import Bifrost from '..';

export default class DLM {
  constructor() {
    this.appInfo = {
      id: 5,
      name: 'Signer',
    };

    this.bifrostSvc = new Bifrost();

    // handler for receiving non-reply messages sent from the backend for this app
    this.recvFn = (msg) => {
      switch (msg.MsgID) {
        // Signer doesn't send us any non-reply messages, so we just log it if it does
        default: {
          console.log('Unknown Signer message', msg);
        }
      }
    };

    this.bifrostSvc.registerAppListener(this.appInfo, this.recvFn);
  }
}
